require('intersection-observer')

import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes/plugins/bgset/ls.bgset'
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'

import {
    CSSPlugin,
    ScrollToPlugin,
} from "gsap/all"

const plugins = [CSSPlugin, ScrollToPlugin]

//const WebFont = require('webfontloader')

/*WebFont.load({
    google: {
        families: ['Montserrat:300,400,500,600']
    },
    fontactive: function(familyName, fvd) {
        console.log("loaded", familyName, fvd)
    },
})*/

// Import style
require('./../scss/main.scss')

// Create SVG sprite
require.context('./../svg/sprite-optimized?optimized', true, /\.svg$/)
// Create SVG sprite
require.context('./../svg/sprite-non-optimized?non-optimized', true, /\.svg$/)

// Create SVG isolated
require.context('./../svg/isolated?isolated', true, /\.svg$/)

// Images
require.context('./../img', true)

require.context('./../fonts', true)
// Videos
//require.context('./../videos', true)

Element.prototype.parents = function (selector) {

    var elements = []
    var elem = this
    var ishaveselector = selector !== undefined

    while ((elem = elem.parentElement) !== null) {
        if (elem.nodeType !== Node.ELEMENT_NODE) {
            continue
        }

        if (!ishaveselector || elem.matches(selector)) {
            elements.push(elem)
        }
    }

    return elements
}

window.getOffsetTop = function (elem) {
    let offsetTop = 0;
    do {
        if (!isNaN(elem.offsetTop)) {
            offsetTop += elem.offsetTop;
        }
    } while (elem = elem.offsetParent);
    return offsetTop;
}

window.getOffsetLeft = function (elem) {
    let offsetLeft = 0;
    do {
        if (!isNaN(elem.offsetLeft)) {
            offsetLeft += elem.offsetLeft;
        }
    } while (elem = elem.offsetParent);
    return offsetLeft;
}

/**
 * Object-fit fallback
 */
if ('objectFit' in document.documentElement.style === false) {

    // assign HTMLCollection with parents of images with objectFit to variable
    const containers = [...document.querySelectorAll('.js-object-fit')]

    // Loop through HTMLCollection
    containers.forEach(container => {
        if (!container) return
        // Assign image source to variable
        const img = container.querySelector('img')
        // Hide image
        img.style.display = 'none'
        // BG cover style
        container.style.backgroundSize = 'cover'
        container.style.backgroundImage = 'url(' + img.src + ')'
        container.style.backgroundPosition = 'center center'
    })

}

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))